export const FB_URL = "https://www.facebook.com/profile.php?id=61585281273016";
export const IG_URL = "https://www.instagram.com/cm_coachandmotivation/";
